import { LitElement as p, css as g, unsafeCSS as v, html as d } from "lit";
import { property as o } from "lit/decorators/property.js";
import m from "hex-rgb";
import "@smartdesign/lit-input";
import { Big as f } from "big.js";
class b {
  constructor() {
    this._rgbaColors = /* @__PURE__ */ new Map(), this._originalColors = /* @__PURE__ */ new Map();
  }
  get colors() {
    return this._originalColors;
  }
  set colors(t) {
    if (this._rgbaColors.clear(), this._originalColors = t, t && t.size) {
      if (Array.from(t.keys()).find((r) => r < 0 || r > 1))
        throw Error(
          "The keys of the colors must represent the relative value where the color is fully applied."
        );
      t.forEach((r, s) => {
        const h = this.convertFromRGBAString(r) || this.convertFromHex(r);
        if (Object.keys(h).length === 0 && h.constructor === Object)
          throw Error(`Cannot convert color: ${r} to rgba-color`);
        this._rgbaColors.set(s, h);
      });
      const i = Array.from(this._rgbaColors.entries()).sort();
      this._rgbaColors = new Map(i);
    }
  }
  blend(t) {
    if (!this._rgbaColors.size)
      throw Error("It is not possible to blend without a color list.");
    let e, i;
    for (const s of this._rgbaColors)
      if (e || (e = s), s[0] < t)
        e = s;
      else if (s[0] === t) {
        e = i = s;
        break;
      } else {
        i = s;
        break;
      }
    i || (i = e);
    const r = i[0] - e[0];
    return r ? this.blendColors(e[1], i[1], (t - e[0]) / r) : this.convertToRGBAString(e[1]);
  }
  blendColors(t, e, i) {
    return this.convertToRGBAString({
      red: Math.round(t.red + (e.red - t.red) * i),
      green: Math.round(t.green + (e.green - t.green) * i),
      blue: Math.round(t.blue + (e.blue - t.blue) * i),
      alpha: t.alpha + (e.alpha - t.alpha) * i
    });
  }
  convertFromHex(t) {
    const e = m(t);
    return e.alpha > 1 && (e.alpha /= 255), e;
  }
  convertFromRGBAString(t) {
    const e = t.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/);
    return e ? {
      red: parseInt(e[1], 10),
      green: parseInt(e[2], 10),
      blue: parseInt(e[3], 10),
      alpha: parseInt(e[4], 10) || 1
    } : null;
  }
  transparentize(t, e) {
    return this.convertToRGBAString(this.convertFromRGBAString(t), e);
  }
  convertToRGBAString(t, e) {
    return `rgba(${t.red},${t.green},${t.blue},${e || t.alpha})`;
  }
}
const C = ":host{display:block;position:relative;width:100%;height:48px;cursor:pointer;touch-action:none;contain:layout style}:host([hidden]){display:none!important}:host([disabled]){opacity:.6;cursor:default;filter:grayscale(100%)}:host([disabled]) sd-lit-input{opacity:1}#track-container{position:absolute;top:50%;left:0;height:2px;overflow:hidden}#track{position:absolute;width:100%;height:100%;transform-origin:left top;will-change:transform}:host(:focus) #thumb{top:11px;left:-14px;border-width:8px}#thumb[active]{top:7px!important;left:-18px!important;border-width:12px!important}#thumb{width:12px;height:12px;position:absolute;top:19px;left:-6px;border-radius:50%;border-width:0;background-clip:padding-box;-webkit-user-select:none;user-select:none;will-change:transform;border-style:solid}sd-lit-input{position:absolute;height:100%;width:50px;right:0;text-align:center;outline:none}sd-field-validation-message{position:absolute;bottom:0}";
var y = Object.defineProperty, x = Object.getOwnPropertyDescriptor, n = (u, t, e, i) => {
  for (var r = i > 1 ? void 0 : i ? x(t, e) : t, s = u.length - 1, h; s >= 0; s--)
    (h = u[s]) && (r = (i ? h(t, e, r) : h(r)) || r);
  return i && r && y(t, e, r), r;
}, l;
const a = (l = class extends p {
  constructor() {
    super(), this.thumbPosition = 0, this._value = 0, this._relativeValue = 0, this.min = 0, this.max = 1, this.colorBlender = new b(), this.baseColor = l.defaultColor, this.resizeObserver = new ResizeObserver(() => {
      window.requestAnimationFrame(() => {
        this.lastKnownWidth !== this.trackContainerWidth && (this.lastKnownWidth = this.trackContainerWidth, this.doUpdateRelativeValue(this._relativeValue, !0));
      });
    });
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.updateInitialValue(), this.addEventListener(
      this.useTouchEvents() ? "touchstart" : "pointerdown",
      (e) => {
        !this.hasAttribute("disabled") && e.composedPath().indexOf(this.inputElement) === -1 && (e.preventDefault(), e.pointerId && this.setPointerCapture(e.pointerId), this.focus(), this.listenMoveEvents(
          e.clientX || e.changedTouches[0].clientX
        ));
      }
    ), this.addEventListener("keydown", this.handleKeyDown, !0), this.setAttribute("aria-valuemin", this.min.toString()), this.setAttribute("aria-valuemax", this.max.toString()), this.hasAttribute("tabindex") || this.setAttribute("tabindex", "0");
  }
  connectedCallback() {
    super.connectedCallback(), ["colors", "min", "max", "step", "editable", "inputSuffix", "value"].forEach((t) => {
      this.upgradeProperty(t);
    }), this.resizeObserver.observe(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.lastKnownWidth = void 0, this.resizeObserver.disconnect();
  }
  upgradeProperty(t) {
    if (Object.prototype.hasOwnProperty.call(this, t)) {
      const e = this[t];
      delete this[t], this[t] = e;
    }
  }
  updateInitialValue() {
    const t = Number.parseFloat(this.getAttribute("value")) || this._value;
    this.setValueInternal(t) && (this.inputElement && (this.inputElement.value = this.formattedValue()), this.fireBothValueChangeEvents());
  }
  shouldUpdate(t) {
    return t.has("step") && this.setValueInternal(this._value) && this.fireBothValueChangeEvents(), super.shouldUpdate(t);
  }
  get value() {
    return this._value;
  }
  set value(t) {
    this.setValueInternal(t) && this.fireBothValueChangeEvents();
  }
  roundToStep(t) {
    let e = Number.parseFloat(t);
    if (Number.isNaN(e))
      return this._value;
    if (this.step) {
      const i = f(e).div(this.step).round().mul(this.step);
      e = Number.parseFloat(i.toString());
    }
    return e;
  }
  setValueInternal(t) {
    const e = this.roundToStep(t);
    if (this._value !== e) {
      const i = this._value;
      return this._value = e, this.relativeValue = (e - this.min) / (this.max - this.min), this.setAttribute("aria-valuenow", this._value.toString()), this.requestUpdate("value", i), !0;
    }
    return !1;
  }
  get relativeValue() {
    return this._relativeValue;
  }
  set relativeValue(t) {
    this._relativeValue !== t && this.doUpdateRelativeValue(t);
  }
  doUpdateRelativeValue(t, e) {
    this._relativeValue = t, this.thumbPosition = Math.min(Math.max(0, t), 1) * this.trackContainerWidth;
    const i = this.min + (this.max - this.min) * this._relativeValue;
    this.setValueInternal(i), !e && this.colors && this.colors.size && (this.baseColor = this.colorBlender.blend(this._relativeValue));
  }
  get colors() {
    return this.colorBlender.colors;
  }
  set colors(t) {
    this.colorBlender.colors = t, this.colors && this.colors.size ? this.baseColor = this.colorBlender.blend(this._relativeValue) : this.baseColor = l.defaultColor;
  }
  static get styles() {
    return [
      g`
                ${v(C)}
            `
    ];
  }
  render() {
    const t = this.colorBlender.transparentize(this.baseColor, 0.26), e = `background-color:${t}; right:${this.editable ? "58px" : "0"}`, i = `transform: scaleX(${this.relativeValue}); background-color:${this.baseColor};`, r = `transform: translateX(${this.thumbPosition}px); background-color:${this.baseColor}; border-color:${t};`;
    return d`
            <div id="track-container" style="${e}">
                <div id="track" style="${i}"></div>
            </div>
            <div id="thumb" ?active="${this.active}" style="${r}"></div>
            ${this.editable && d`
                <sd-lit-input
                    .value="${this.formattedValue()}"
                    @value-change="${this.onInputValueChange}"
                    ?disabled="${this.disabled}"
                    ><span slot="suffix">${this.inputSuffix}</span>
                </sd-lit-input>
            `}
            ${this.validationMessage && d`
                <sd-field-validation-message
                    .message="${this.validationMessage}"
                    .icon="${this.validationIconSrc}"
                    .level="${this.validationLevel}"
                >
                </sd-field-validation-message>
            `}
        `;
  }
  listenMoveEvents(t) {
    this.active = !0, this.onPointerMove(t);
    const e = [], i = (s) => {
      s.stopPropagation(), s.preventDefault(), this.onPointerMove(s.clientX || s.changedTouches && s.changedTouches[0].clientX);
    }, r = () => {
      this.active = !1, e.forEach((s) => s.remove()), this.fireValueChange();
    };
    this.useTouchEvents() ? (e.push(this.addPointerEventListener("touchmove", i)), e.push(this.addPointerEventListener("touchend", r)), e.push(this.addPointerEventListener("touchcancel", r))) : (e.push(this.addPointerEventListener("pointermove", i)), e.push(this.addPointerEventListener("pointerup", r)));
  }
  onPointerMove(t) {
    this.updateAlreadyRequested || (this.updateAlreadyRequested = !0, window.requestAnimationFrame(async () => {
      this.updateAlreadyRequested = !1, this.updateThumbPosition(t);
      const e = this.relativeValue;
      this.relativeValue = this.thumbPosition / this.trackContainerWidth, this.relativeValue !== e && (await this.updateComplete, this.fireValueChange(!0), this.active || this.fireValueChange());
    }));
  }
  addPointerEventListener(t, e) {
    return window.addEventListener(t, e, !0), {
      remove: () => {
        window.removeEventListener(t, e, !0);
      }
    };
  }
  updateThumbPosition(t) {
    if (this.thumbPosition = Math.min(
      this.trackContainerWidth,
      Math.max(0, t - this.getBoundingClientRect().left)
    ), this.max - this.min > 1) {
      const e = this.trackContainerWidth / (this.max - this.min), i = this.thumbPosition % e;
      i && (i < e / 2 ? this.thumbPosition -= i : this.thumbPosition += e - i);
    }
  }
  onInputValueChange(t) {
    this.value = Number(t.detail.value.replace(RegExp(this.escapedDecimalSeparator), ".")), String(this.value) !== String(t.detail.value) && (t.target.value = String(this.value));
  }
  formattedValue() {
    return this.value.toString().replace(/\./, this.decimalSeparatorOrDefault);
  }
  get escapedDecimalSeparator() {
    return this.decimalSeparatorOrDefault.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  }
  get decimalSeparatorOrDefault() {
    return this.decimalSeparator || 1.1.toLocaleString(this.navigatorLanguage).substring(1, 2);
  }
  get navigatorLanguage() {
    return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || "en";
  }
  handleKeyDown(t) {
    if (!this.hasAttribute("disabled") && t.composedPath().indexOf(this.inputElement) === -1) {
      let e = this.step || (this.max - this.min) / 100;
      switch (this.max - this.min > 1 && (e = Math.round(e) || 1), t.keyCode) {
        case 37:
        case 40:
          this.value = Math.max(this.value - e, this.min), t.preventDefault();
          break;
        case 38:
        case 39:
          this.value = Math.min(this.value + e, this.max), t.preventDefault();
          break;
      }
    }
  }
  get inputElement() {
    return this._inputElement || (this._inputElement = this.shadowRoot.querySelector("sd-lit-input")), this._inputElement;
  }
  get trackContainer() {
    return this._trackContainer || (this._trackContainer = this.shadowRoot.querySelector("#track-container")), this._trackContainer;
  }
  get trackContainerWidth() {
    return this.trackContainer && this.trackContainer.offsetWidth;
  }
  fireBothValueChangeEvents() {
    this.fireValueChange(!0), this.fireValueChange();
  }
  fireValueChange(t) {
    this.dispatchEvent(
      new CustomEvent(`${t ? "immediate-" : ""}value-change`, {
        detail: { value: this.value }
      })
    );
  }
  useTouchEvents() {
    return this.hasAttribute("use-touch-events");
  }
}, l.ID = "sd-lit-slider", l.defaultColor = "rgb(20, 103, 186)", l);
n([
  o({ type: Number })
], a.prototype, "thumbPosition", 2);
n([
  o({ type: Number, reflect: !0 })
], a.prototype, "min", 2);
n([
  o({ type: Number, reflect: !0 })
], a.prototype, "max", 2);
n([
  o({ type: Number, reflect: !0 })
], a.prototype, "step", 2);
n([
  o({ type: Boolean, reflect: !0 })
], a.prototype, "editable", 2);
n([
  o({ type: String, reflect: !0 })
], a.prototype, "inputSuffix", 2);
n([
  o({ type: Boolean, reflect: !0 })
], a.prototype, "disabled", 2);
n([
  o({ type: String, attribute: !0 })
], a.prototype, "validationMessage", 2);
n([
  o({ type: String, attribute: !0 })
], a.prototype, "validationIconSrc", 2);
n([
  o({ type: String, attribute: !0 })
], a.prototype, "validationLevel", 2);
n([
  o({ type: String, attribute: !0 })
], a.prototype, "decimalSeparator", 2);
n([
  o({ type: Boolean })
], a.prototype, "active", 2);
n([
  o()
], a.prototype, "baseColor", 2);
let c = a;
customElements.get(c.ID) || customElements.define(c.ID, c);
export {
  c as default
};
//# sourceMappingURL=slider.mjs.map
